var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.98005L11.6667 3.98005M11.6667 3.98005C11.6667 5.51856 12.8606 6.76576 14.3333 6.76576C15.8061 6.76576 17 5.51856 17 3.98005C17 2.44154 15.8061 1.19434 14.3333 1.19434C12.8606 1.19434 11.6667 2.44154 11.6667 3.98005ZM6.33333 11.4086L17 11.4086M6.33333 11.4086C6.33333 12.9471 5.13943 14.1943 3.66667 14.1943C2.19391 14.1943 1 12.9471 1 11.4086C1 9.87011 2.19391 8.62291 3.66667 8.62291C5.13943 8.62291 6.33333 9.87011 6.33333 11.4086Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.4249455e6fc101903b86ff45d60ecac6.svg";
export { ForwardRef as ReactComponent };